import { Injectable } from '@angular/core';
import { ZebraBrowserPrint, ZebraPrinter } from '../../shared/models/zebra';

declare var BrowserPrint: typeof ZebraBrowserPrint;
@Injectable({ providedIn: 'root' })
export class ZebraService {
  private printer: any;

  private mappingStartingNames = new Map<'ZD200' | 'ZD400', string | string[]>([
    ['ZD200', 'd4'],
    ['ZD400', ['df', '50n']],
  ]);

  async initPrinter(): Promise<void> {
    return new Promise((resolve, reject) => {
      BrowserPrint.getDefaultDevice(
        'printer',
        (device: any) => {
          if (!device) {
            reject('No se encontró impresora Zebra');
            return;
          }

          this.printer = device;
          resolve();
        },
        (error: any) => {
          reject(error);
        }
      );
    });
  }
  sendZpl(zpl: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.printer) {
        reject('Impresora no inicializada');
        return;
      }

      try {
        this.printer.sendErrorCallback = (error: any) => {
          console.log('here 1');
          reject(error);
        };
        this.printer.send(
          zpl,
          (err) => {
            if (
              typeof err === 'string' &&
              err.toLowerCase().includes('failed to write to device')
            ) {
              reject('Impresora no disponible');
              return;
            }
            resolve();
          },
          this.printer.sendErrorCallback
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  async printSpecificPrinter(
    zpl: string,
    printerName: 'ZD200' | 'ZD400'
  ): Promise<any> {
    return new Promise<ZebraPrinter>((resolve, reject) => {
      BrowserPrint.getLocalDevices(
        ({ printer }) => {
          if (!printer || printer.length === 0) {
            reject('No se encontró impresora Zebra');
            return;
          }
          if (printer.length === 1) {
            resolve(printer[0]);
          }
          const startingName: string | string[] =
            this.mappingStartingNames.get(printerName);
          resolve(
            printer.find((res) =>
              Array.isArray(startingName)
                ? startingName.some((name) => res.name.startsWith(name))
                : res.name.startsWith(startingName)
            )
          );
        },
        (error: any) => {
          reject(error);
        }
      );
    }).then((printer) => {
      return new Promise((resolve, reject) => {
        try {
          console.log(printer);

          // Configurar timeout de 5 segundos
          const timeoutId = setTimeout(() => {
            reject('Timeout: La impresora no respondió en 5 segundos');
          }, 5000);

          printer.sendErrorCallback = (error: any) => {
            console.log('Error on sendCallback printer');
            clearTimeout(timeoutId);
            reject(error);
          };

          printer.send(
            zpl,
            (err) => {
              clearTimeout(timeoutId);
              if (
                typeof err === 'string' &&
                err.toLowerCase().includes('failed to write to device')
              ) {
                console.log('Error on printer not available');
                reject('Impresora no disponible');
                return;
              }
              resolve(true);
            },
            printer.sendErrorCallback
          );
        } catch (error) {
          console.log('Error on catch printer');
          reject(error);
        }
      });
    });
  }

  async printZpl(zpl: string, cantidad: number = 1): Promise<void> {
    console.log(this.printer);
    for (let i = 0; i < cantidad; i++) {
      await this.sendZpl(zpl);
      console.log(`Etiqueta ${i + 1} enviada`);
    }
  }
}
